<div
  class="portal-dropdown-toggle"
  #tippy="tippy"
  [appendTo]="appendTo"
  [arrow]="arrow"
  [distance]="distance"
  [hideOnClick]="true"
  [placement]="_placement"
  [popover]="true"
  [portalTippy]="dropdown"
  [sticky]="true"
  [theme]="theme"
  [tippyDisabled]="disabled"
  [triggerTarget]="trigger"
  (hidden)="hidden.emit()"
  (keydown.escape)="closePopover()"
  (shown)="shown.emit()"
  trigger="click"
>
  <div #trigger (click)="onClick($event)">
    <ng-container *portalTransclusion="transclusions; name: 'toggle'">
      @if (buttonToggle) {
        <button
          class="btn btn-outline-primary portal-dropdown-toggle--button"
          [ngClass]="buttonClass"
          [portalTippy]="tooltip | translate"
          appendTo="body"
        >
          <ng-content select="[toggle]"></ng-content>
        </button>
      } @else {
        <portal-icon-button
          [iconClass]="_icon"
          [portalTippy]="tooltip | translate"
          appendTo="body"
        ></portal-icon-button>
      }
    </ng-container>
  </div>
</div>

<ng-template #dropdown>
  <div class="custom-dropdown portal-dropdown" [class]="dropdownClass">
    <ng-content></ng-content>
  </div>
</ng-template>
